import { render, staticRenderFns } from "./ChooseDAC.vue?vue&type=template&id=2dc8e955&scoped=true&"
import script from "./ChooseDAC.vue?vue&type=script&lang=js&"
export * from "./ChooseDAC.vue?vue&type=script&lang=js&"
import style0 from "./ChooseDAC.vue?vue&type=style&index=0&id=2dc8e955&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8e955",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSlider } from 'vuetify/lib'
installComponents(component, {VFlex,VIcon,VLayout,VSlider})
